import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IPublicTrainer} from "../../models/Trainer";

interface TrainersState {
    trainers: IPublicTrainer[];
    visibleTrainer: IPublicTrainer[];
    isTrainerLoading: boolean;
}

const initialState: TrainersState = {
    trainers: [],
    visibleTrainer: [],
    isTrainerLoading: true,
}

export const trainersSlice = createSlice({
    name: "trainers",
    initialState,
    reducers: {
        setTrainers: (state, action: PayloadAction<IPublicTrainer[]>) => {
            state.trainers = action.payload;
            state.isTrainerLoading = false;
            state.visibleTrainer = action.payload.filter(el => el.visibleForWebsite);
        }
    },
})

export const {setTrainers} = trainersSlice.actions;

export default trainersSlice.reducer;